import React from 'react';
import { IProps as IFeatureLinksIconsBlockProps } from './FeatureLinksIconsBlock.interface';
import { FeatureLinksIconsBlock } from './FeatureLinksIconsBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

interface IFeatureLinksIconsBlockInputProps {
    heading: string;
    description: string;
    items: Array<{
        icon: string;
        iconBackground?: {
            defaultSrc: string;
        } | null;
        heading: string;
        description: string;
        link: {
            text?: string;
            target?: string | null;
            href: string;
            title?: string | null;
            ariaLabel?: string | null;
        } | null;
    }>;
    columns: number;
    cardType: 'horizontal' | 'vertical' | 'compact';
    buttons: any[] | null;
    background: ThemeColors;
    [key: string]: any;
}

const mapInputToProps = (
    input: IFeatureLinksIconsBlockInputProps
): IFeatureLinksIconsBlockProps => {

    return {
        ...input,
        heading: input.heading,
        description: input.description,
        buttons: input.buttons
            ? input.buttons.map((button) => translation.mapAnchorProps(button))
            : undefined,
        cards: input.items.map((item) => ({
            icon: item.icon,
            iconBackground: item.iconBackground?.defaultSrc,
            heading: item.heading,
            description: item.description,
            link: item.link ? translation.mapAnchorProps(item.link) : undefined,
        })),
        cardType: input.cardType || 'horizontal',
        columns: input.columns || 2,
        backgroundColor: input.background || 'white',
    } as IFeatureLinksIconsBlockProps;
};

const FeatureLinksIconsBlockTranslation: React.FC<IFeatureLinksIconsBlockInputProps> = (
    inputProps
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={FeatureLinksIconsBlock}
        mapProps={mapInputToProps}
    />
);

export default FeatureLinksIconsBlockTranslation;